import { message } from 'antd'
import RequestError from '../../services/RequestError'
import { RequestErrorObject } from '../../types'

const isArrayOfErrors = (toBeDetermined: RequestErrorObject | RequestErrorObject[]): toBeDetermined is RequestErrorObject[] => {
	return Array.isArray(toBeDetermined as RequestErrorObject[])
}

export default (error: RequestError | Error, createErrorObject: (error: RequestError) => RequestErrorObject[] | RequestErrorObject): void => {
	if (error instanceof RequestError) {
		const errorObject = createErrorObject(error)
		if (isArrayOfErrors(errorObject)) errorObject.forEach(elem => message.error(elem.description))
		else message.error(errorObject.description)
	} else message.error(error.message)
}
